import { Box, Typography } from '@mui/material';
import React from 'react';
import InformationCard from './InformationCard';

const OnsiteMeetingCard = ({ customStyle = {
    headingFont: "grenettepromedium",
    bodyFont: "grenetteproregular",
    textColor: "var(--color-black)",
    secondaryTextColor: "#878787",
}, meetingLocation = "" }) => {
    return (
        (
            <Box
                sx={{
                    mt: "30px",
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontFamily: `var(--font-${customStyle?.headingFont})`,
                            fontSize: "18px",
                            lineHeight: "23px",
                            color: customStyle?.textColor ?? "var(--color-black)",
                        }}
                    >
                        Onsite Meeting
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: customStyle?.secondaryTextColor ?? "#878787",
                            fontFamily: `var(--font-${customStyle?.bodyFont})`,
                        }}
                    >
                        This session takes place in person. Video conference is not
                        available for onsite meetings.
                    </Typography>
                </Box>

                <Box sx={{ mt: "20px" }}>
                    <InformationCard
                        customStyle={customStyle}
                        label={
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        lineHeight: "16px",
                                        color: customStyle?.secondaryTextColor ?? "#878787",
                                        fontFamily: `var(--font-${customStyle?.bodyFont})`,
                                        mb: "4px",
                                    }}
                                >
                                    Meeting Location
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        lineHeight: "normal",
                                        color: customStyle?.textColor ?? "var(--color-black)",
                                        fontFamily: `var(--font-${customStyle?.bodyFont})`,
                                        whiteSpace: "pre-wrap",
                                    }}
                                >
                                    {meetingLocation}
                                </Typography>
                            </Box>
                        }
                    />
                </Box>
            </Box>
        )
    );
};

export default OnsiteMeetingCard;
